import type { IProductLean } from "./product-lean/product-lean.entity.interface";
import type { IProductsAvailabilities } from "./products-availabilities.entity.interface";

export class ProductsAvailabilities implements IProductsAvailabilities {
  productsAvailable: IProductLean[];
  productsNotAvailable: IProductLean[];

  constructor(productsAvailable: IProductLean[], productsNotAvailable: IProductLean[]) {
    this.productsAvailable = productsAvailable;
    this.productsNotAvailable = productsNotAvailable;
  }
}
